import axios from "axios";
import { apiServicesUrl } from "./baseUrl";
import { userAccessToken } from "../helpers";
export const fetchAllPracticeAndLocation = async (show_id,status) => {
  try {
    const response = await axios.get(
      `${apiServicesUrl}/all/practice-and-location?show_id=${show_id}&show_status=${status}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  }  catch (error) {
    if (error.response?.status === 404) {
      return "Never";
    }

    console.error("Error fetching last updated time:", error);
    return {
      error: true,
      message: error.response?.data?.message || "An error occurred while fetching all Practice and Location.",
    };
  }
};

export const changePracticeStatus = async (account_id,formData) => {
  try {
    const response = await axios.patch(`${apiServicesUrl}/change-practice-status/account_id=${account_id}`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    if (error.response?.status === 404) {
      return "Never";
    }

    console.error("Error fetching last updated time:", error);
    return {
      error: true,
      message: error.response || "An error occurred while changing PracticeLocation status.",
    };
  }
};
export const changePracticeLocationStatus = async (location_id,formData) => {
  try {
    const response = await axios.patch(`${apiServicesUrl}/change-location-status/location_id=${location_id}`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    if (error.response?.status === 404) {
      return "Never";
    }

    console.error("Error fetching last updated time:", error);
    return {
      error: true,
      message: error.response || "An error occurred while changing PracticeLocation status.",
    };
  }
};
